// extracted by mini-css-extract-plugin
export default {"root":"MinimizeButton_root__IB-Xw","icon":"MinimizeButton_icon__YpPi9"};